import { axiosApplication } from "@config/axiosConfig";

export const submitRenewalRequestAPI = async (payload: any) => {
  return await axiosApplication.post(`/renewal-request`, payload);
};

export const fetchRenewalRequestAPI = async (applicationId: any) => {
  return await axiosApplication.get(
    `/renewal-request-details?applicationId=${applicationId}`,
  );
};

export const submitRenewalRequestZeroFee = async (applicationId: any) => {
  return await axiosApplication.post(
    `/renewal-request-submit/${applicationId}`,
  );
};
